import React from 'react';
import classnames from 'classnames';
import BasicUserAvatar from '../BasicUserAvatar';
import UserSymbol from '../UserSymbol';
import { getUserType } from '../../helpers';
import s from './UserAvatarWithSymbol.scss';
export var UserAvatarWithSymbol = function (_a) {
    var user = _a.user, _b = _a.showSymbol, showSymbol = _b === void 0 ? false : _b, _c = _a.showHighlight, showHighlight = _c === void 0 ? false : _c, symbolClassName = _a.symbolClassName, highlightClassName = _a.highlightClassName, ariaHidden = _a["aria-hidden"];
    return (React.createElement(React.Fragment, null,
        showSymbol && (React.createElement(UserSymbol, { userType: getUserType(user), className: classnames(s['symbol'], symbolClassName) })),
        showHighlight && (React.createElement("span", { className: classnames(s['highlight'], highlightClassName) })),
        React.createElement(BasicUserAvatar, { user: user, "aria-hidden": ariaHidden })));
};
UserAvatarWithSymbol.displayName = 'UserAvatarWithSymbol';
export default UserAvatarWithSymbol;
//# sourceMappingURL=UserAvatarWithSymbol.js.map